<!-- =========================================================================================
  File Name: DashboardAnalytics.vue
  Description: Dashboard Analytics
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <!-- CARD 1: CONGRATS -->
      <div class="vx-col w-full mb-base">
        <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
          <img
            src="@/assets/images/elements/decore-left.png"
            class="decore-left"
            alt="Decore Left"
            width="200"
          />
          <img
            src="@/assets/images/elements/decore-right.png"
            class="decore-right"
            alt="Decore Right"
            width="175"
          />
          <feather-icon
            icon="AwardIcon"
            class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
            svgClasses="h-8 w-8"
          ></feather-icon>
          <h1 class="mb-6 text-white">Selamat Datang {{ profile.profile.name }}</h1>
          <!-- <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">You have done <strong>{{ checkpointReward.progress }}</strong> more sales today. Check your new badge in your profile.</p> -->
        </vx-card>
      </div>

      <!-- CARD 2: SUBSCRIBERS GAINED -->
      <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-6/12 xl:w-6/12 mb-base">
        <statistics-card-line icon="GridIcon" :statistic="totalCampign" statisticTitle="Total Campaign" :chartData="subscribersGained.series" type="area"></statistics-card-line>
      </div>

      <!-- CARD 3: ORDER RECIEVED -->
      <!-- <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-4/12 xl:w-4/12 mb-base">
        <statistics-card-line icon="UsersIcon" statistic="300" statisticTitle="User Aktif" :chartData="ordersRecevied.series" color="warning" type="area"></statistics-card-line>
      </div> -->

      <div class="vx-col w-full sm:w-full md:w-1/2 lg:w-6/12 xl:w-6/12 mb-base">
        <statistics-card-line icon="CreditCardIcon" :statistic="transaksi" statisticTitle="Total Transaksi" :chartData="ordersRecevied.series" color="#0046b8" type="area"></statistics-card-line>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import analyticsData from "./ui-elements/card/analyticsData.js";
import ChangeTimeDurationDropdown from "@/components/ChangeTimeDurationDropdown.vue";
import VxTimeline from "@/components/timeline/VxTimeline";
import url from '@/url.js'

export default {
  computed: {
    profile() {
      return this.$store.state.auth.profileAccess;
    },
  },
  data() {
    return {
      checkpointReward: {},
      subscribersGained: {},
      ordersRecevied: {},
      salesBarSession: {},
      supportTracker: {},
      productsOrder: {},
      totalCampign : null,
      transaksi : null,
      salesRadar: {},
      id : localStorage.getItem("profileAccess"),
      timelineData: [
        {
          color: "primary",
          icon: "PlusIcon",
          title: "Client Meeting",
          desc: "Bonbon macaroon jelly beans gummi bears jelly lollipop apple",
          time: "25 mins Ago",
        },
        {
          color: "warning",
          icon: "MailIcon",
          title: "Email Newsletter",
          desc: "Cupcake gummi bears soufflé caramels candy",
          time: "15 Days Ago",
        },
        {
          color: "danger",
          icon: "UsersIcon",
          title: "Plan Webinar",
          desc: "Candy ice cream cake. Halvah gummi bears",
          time: "20 days ago",
        },
        {
          color: "success",
          icon: "LayoutIcon",
          title: "Launch Website",
          desc:
            "Candy ice cream cake. Halvah gummi bears Cupcake gummi bears soufflé caramels candy.",
          time: "25 days ago",
        },
        {
          color: "primary",
          icon: "TvIcon",
          title: "Marketing",
          desc: "Candy ice cream cake. Halvah gummi bears Cupcake gummi bears.",
          time: "28 days ago",
        },
      ],

      analyticsData,
      dispatchedOrders: [],
    };
  },
  components: {
    VueApexCharts,
    StatisticsCardLine,
    ChangeTimeDurationDropdown,
    VxTimeline,
  },
  created() {
    const parser = JSON.parse(this.id);
    //  User Reward Card
    this.$http
      .get(`${url.base}/dashboard/${parser.profile.id}`,{
        headers:{
          'Authorization' : `Bearer ${parser.token}`,
          secret : url.secret
        }
      })
      .then((response) => {

        this.checkpointReward = response.data;
        this.totalCampign = response.data.totalCampign;
        this.transaksi = response.data.transaksi;
      })
      .catch((error) => {
        console.log(error);
      });

    // Subscribers gained - Statistics
    // this.$http
    //   .get(`/dashboard/`)
    //   .then((response) => {
    //     this.subscribersGained = response.data;
    //     console.log(response.data);
    //   })
    //   .catch((error) => {
    //     console.log(error);
    //   });

    // Orders - Statistics
    this.$http
      .get("/api/card/card-statistics/orders")
      .then((response) => {
        this.ordersRecevied = response.data;
      })
      .catch((error) => {
        console.log(error);
      });

    // Sales bar - Analytics
    this.$http
      .get("/api/card/card-analytics/sales/bar")
      .then((response) => {
        this.salesBarSession = response.data;
      })
      .catch((error) => {
        console.log(error);
      });

    // Support Tracker
    this.$http
      .get("/api/card/card-analytics/support-tracker")
      .then((response) => {
        this.supportTracker = response.data;
      })
      .catch((error) => {
        console.log(error);
      });

    // Products Order
    this.$http
      .get("/api/card/card-analytics/products-orders")
      .then((response) => {
        this.productsOrder = response.data;
      })
      .catch((error) => {
        console.log(error);
      });

    // Sales Radar
    this.$http
      .get("/api/card/card-analytics/sales/radar")
      .then((response) => {
        this.salesRadar = response.data;
      })
      .catch((error) => {
        console.log(error);
      });

    // Dispatched Orders
    this.$http
      .get("/api/table/dispatched-orders")
      .then((response) => {
        this.dispatchedOrders = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
